import { NgRedux } from '@redux/redux-compatibility.service';
import { Component, OnInit } from '@angular/core';
import { Catalog } from 'src/app/shared/models/cat.model';
import { IgnoredWord } from 'src/app/shared/models/common';
import { AppState } from 'src/app/shared/redux/store';
import { GrammarSpellingCheckService } from 'src/app/shared/services/grammar-spelling-check.service';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'spelling-check-ignored',
    templateUrl: './spelling-check-ignored.component.html',
    styleUrls: ['./spelling-check-ignored.component.scss'],
    standalone: false
})
export class SpellingCheckIgnoredComponent implements OnInit {
  spellingCheckIgnored: IgnoredWord[];
  loading: boolean;
  addSpellingCheckIgnoredOpenSw: boolean;

  constructor(
    private ngRedux: NgRedux<AppState>,
    private grammarSpellingCheckService: GrammarSpellingCheckService,
    private sharedService: SharedService,
  ) {}

  get cat(): Catalog {
    return this.ngRedux.getState().curCat;
  }

  ngOnInit(): void {
    this.loading = true;
    this.grammarSpellingCheckService.getCatSpellingCheckIgnoredWords(this.cat.catId).subscribe(
      (data) => {
        this.spellingCheckIgnored = data;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
      }
    );
  }

  delete(ignoredWord: IgnoredWord) {
    this.loading = true;
    this.grammarSpellingCheckService.deleteCatSpellingCheckIgnoredWord(this.cat.catId, ignoredWord.wordId, ignoredWord.isGlobal).subscribe(
      () => {
        this.spellingCheckIgnored = this.spellingCheckIgnored.filter(word => word.word != ignoredWord.word);
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
      }
    )
  }

  add(word: IgnoredWord) {
    this.addSpellingCheckIgnoredOpenSw = false;
    this.loading = true;

    this.grammarSpellingCheckService.addCatSpellingCheckIgnoredWords(this.cat.catId, [word]).subscribe(
      newWords => {
        for (let newWord of newWords) {
          this.spellingCheckIgnored = this.spellingCheckIgnored.filter(word => word.word !== newWord.word);
          this.spellingCheckIgnored.push(newWord);
        }
        this.spellingCheckIgnored.sort((a, b) => a.word.localeCompare(b.word));
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
      }
    )
  }

}
